export default "__VITE_ASSET__CK8q$RcS__"